import { watch } from 'vue'

import type { AssessmentResultData } from '@ts-assessment/interfaces'

import { useDisciplineStore } from '@stores/discipline'
import { useAssessmentResultStore } from '@stores/assessment-result'

import { useAssessmentResultApi } from '@api/assessments-result/assessments-result.hook'
import { useAssessmentResult } from '@hooks/assessments-result/assessment-results.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(async (to) => {
  const disciplineStore = useDisciplineStore()
  const assessmentResultStore = useAssessmentResultStore()
  const { initAssessmentResult } = useAssessmentResult()

  watch(() => disciplineStore.hasDisciplineInfo, (hasInfo) => {
    if (!hasInfo) return
    void useAssessmentResultApi({
      params: to.params,
    }, {
      onStart: () => assessmentResultStore.setLoading(true),
      onSuccess: (data: AssessmentResultData) => {
        initAssessmentResult(data)
      },
      onError: () => assessmentResultStore.setLoading(false),
      onFinish: () => assessmentResultStore.setLoading(false),
    })
  })
})
